import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "./summary.css";
import TotalPrice from "./total-price";
import { getEstateName, pick, _ } from "../../model/utils";

// stay = 1, experience = 2, table = 4
const translations = [
  undefined,
  _.stay,
  _.experience,
  _.stayAndExperience,
  _.table,
  _.stayAndTable,
  _.experienceAndTable,
  _.stayExperienceAndTable
];

const Summary = ({
  hasExperience: hasExperienceTick,
  selectedExperiences,
  roomKind,
  hidePriceInLowRes,
  reservationType,
  hasRoomKind
}) => {
  const hasExperience =
    hasExperienceTick && selectedExperiences && selectedExperiences.length > 0;
  const hasRoom = hasRoomKind && !!roomKind;
  const hasTable = false; // TODO: quando viene messo il check in experience

  // TODO: semplificare l'espressione qui sotto in modo da considerare i flag anche con table
  const index =
    (reservationType === "room" || hasRoom ? 1 : 0) +
    (reservationType == "experience" || hasExperience ? 2 : 0) +
    (reservationType == "table" || hasTable ? 4 : 0);
  const header = translations[index] || "<unknown>";

  return (
    <div className="row">
      <div className="col-12 col-md-9">
        <div styleName="text">
          {header}
          {/* {reservationType === "room"
            ? hasExperience
              ? _.stayAndExperience
              : _.stay
            : reservationType === "experience"
            ? hasRoom
              ? _.stayAndExperience
              : _.experience
            : "<unknown>"} */}
          {}
          &nbsp;
          {getEstateName()}
        </div>
      </div>
      <div className="col-12 col-md-3">
        <TotalPrice hidePriceInLowRes={hidePriceInLowRes} />
      </div>
    </div>
  );
};

Summary.propTypes = {
  hasExperience: PropTypes.bool,
  selectedExperiences: PropTypes.arrayOf(PropTypes.object),
  hasRoomKind: PropTypes.bool,
  roomKind: PropTypes.object,
  hidePriceInLowRes: PropTypes.bool,
  reservationType: PropTypes.oneOf(["room", "experience", "table"])
};

export default connect(
  pick([
    "hasExperience",
    "selectedExperiences",
    "hasRoomKind",
    "roomKind",
    "reservationType"
  ])
)(Summary);
